import { render, staticRenderFns } from "./SelectDomain.vue?vue&type=template&id=0801730a&scoped=true&"
import script from "./SelectDomain.vue?vue&type=script&lang=js&"
export * from "./SelectDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801730a",
  null
  
)

export default component.exports